export default {
  'login.Release your inner lion and let it roar':
    'Release your inner lion and let it roar',
  'login.Log In': 'Log In',
  'login.Please input Lion ID': 'Please input Lion ID',
  'login.Please enter your password': 'Please enter your password',
  'login.Password': 'Password',
  'login.Remember my information': 'Remember my information',
  'login.Register': 'Register',
  'login.Forget Password': 'Forget Password',
  'login.Registration': 'Registration',
  'login.Send Code': 'Send Code',
  'login.Email': 'Email',
  'login.Verification code': 'Verification code',
  'login.Please enter the Vertification code received from the email':
    'Please enter the Vertification code received from the email',
  'login.Confirm password': 'Confirm password',
  'login.Submit': 'Submit',
  'login.Reset your password': 'Reset your password',
  'login.Please input a Valid Lion ID': 'Please input a Valid Lion ID',
  'login.Password must be 8-12 characters,no spaces and must contain at lease 3 of these characters:1 uppercase,1 lowercase,1 number':
    'Password must be 8-12 characters,no spaces and must contain at lease 3 of these characters:1 uppercase,1 lowercase,1 number',
  'login.Return to Login Page': 'Return to Login Page',
  'login.Your password do not match. Please try again':
    'Your password do not match. Please try again',
  'login.Registered Successfully': 'Registered Successfully',
  'login.Password Reset Successfully': 'Password Reset Successfully',
}
